import PopUpView from '@monofe/ui-common/alert/PopUpView';
import { Suspense } from 'react';
import type { IDialogMessage } from '../interface';
import actions from '../state/slice';
import { dispatchAction } from '../state/store';
import { MESSAGE_DEFAULTS } from '../util/constants';

function AlertView(props: { messages: IDialogMessage[] }): JSX.Element {
    const onAccept = (item: IDialogMessage) => () => {
        const shouldDelete = item.options?.removeOnHide ?? true;
        dispatchAction(shouldDelete ? actions.removePopUp(item) : actions.hidePopUp(item));
        item.onAccept?.();
    };

    const onDecline = (item: IDialogMessage) => () => {
        const shouldDelete = item.options?.removeOnHide ?? true;
        dispatchAction(shouldDelete ? actions.removePopUp(item) : actions.hidePopUp(item));
        item.onDecline?.();
    };

    return (
        <Suspense fallback={null}>
            {props.messages
                .filter(item => item.show ?? false)
                .map(item => (
                    <PopUpView
                        {...item}
                        key={item.id}
                        onAccept={onAccept(item)}
                        onDecline={onDecline(item)}
                        textAccept={item.textAccept ?? MESSAGE_DEFAULTS.textAccept}
                        textDecline={item.textDecline ?? MESSAGE_DEFAULTS.textDecline}
                    />
                ))}
        </Suspense>
    );
}

export default AlertView;
